import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  async lookup(event) {
    const { url, query, source, status, found, failure } = event.params
    const value = document.getElementById(source)?.value?.trim()
    if (!value) return

    const button = event.currentTarget
    button.disabled = true
    try {
      const response = await fetch(this.buildUrl(url, query, value), { headers: { Accept: "application/json" } })
      if (!response.ok) return this.report(status, failure, false)

      this.fill(await response.json())
      this.report(status, found, true)
    } catch {
      this.report(status, failure, false)
    } finally {
      button.disabled = false
    }
  }

  buildUrl(path, query, value) {
    const url = new URL(path, window.location.origin)
    url.searchParams.set(query, value)
    return url
  }

  fill(data) {
    this.fieldTargets.forEach((input) => {
      const value = data[input.dataset.lookupFillKey]
      if (value === undefined || value === null || value === "") return

      input.value = value
      input.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  report(statusId, message, ok) {
    const element = document.getElementById(statusId)
    if (!element) return

    element.textContent = message
    element.hidden = false
    element.classList.toggle("is-error", !ok)
  }
}
